import axios from "axios";
import axiosRetry from "axios-retry";
import { getSsoToken } from "../../util";
import i18n from "i18next";

const apiClient = axios.create({
  baseURL: process.env.BACKEND_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 3000, // 3s
});

axiosRetry(apiClient, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) =>
    axiosRetry.isNetworkOrIdempotentRequestError(error) || (error.response?.status ?? 0) >= 500,
  onRetry: (retryCount, error) =>
    console.warn(`Retrying request (${retryCount}/3):`, error.message),
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getSsoToken();
  config.headers.Authorization = `Bearer ${token}`;

  let language = i18n.language;
  if (config.languageOverride) language = config.languageOverride;
  config.headers["X-Accept-Language"] = language;

  return config;
});

export default apiClient;
